import React from "react"
import {openURL} from "./shared/url-opener"

export default React.memo(({navigation}) => {
  React.useEffect(() => {
    openURL('/cv.pdf')
    navigation.goBack()
  })
  return <></>
})